export default function itemsUI() {
	$('.items').each(function() {
		const $itemsContainer = $(this);
		const $items = $itemsContainer.find('.item');

		if ( $items.length > 3 ) {
			$itemsContainer.addClass('items--not-centered');
		}
	})
}
